module.exports = __webpack_public_path__ + "img/user_types.2d16ad39.svg";